import defaultAvator from '@/assets/images/icon_default_avatar.png';
const mutations = {
  // 设置保险员公司信息
  muSetUserCompany(state, info) {
    state.userCompanyObject = info;
  },
  // 判断是否是分销人员
  muCheckIstoBUser(state, status) {
    state.isToBUser = status;
  },
  // 设置订单列表数据
  muSetOrderList(state, data) {
    state.orderList = data;
  },
  // 设置订单详情
  muSetOrderDetail(state, data) {
    state.orderDetailObject = data;
  },
  // 订单详情中的领取数据
  muSetOrderDetailReceiveList(state, data) {
    data.data.list.forEach(item => {
      !item.receiveWxAvatar && (item.receiveWxAvatar = defaultAvator);
    });
    if (state.orderDetailReceiveList.length < data.data.total) {
      state.orderDetailReceiveList = [...state.orderDetailReceiveList, ...data.data.list];
    }
  },
  // 获取分享订单详情
  muSetShareOrderDetail(state, data) {
    data.details = JSON.parse(data.descImage);
    state.shareOrderDetailObject = data;
  },
  // 获取分享领取数据
  muSetShareReceivedList(state, data) {
    data.receiveList.list.forEach(item => {
      !item.receiveWxAvatar && (item.receiveWxAvatar = defaultAvator);
    });

    if (data.receiveList.pageNum === 1) {
      state.shareReceivedList = data.receiveList.list;
    } else {
      state.shareReceivedList = [...state.shareReceivedList, ...data.receiveList.list];
    }
    state.shareReceivedObject = data;
  },
  muSetGiveNumber(state, num) {
    state.giveNumber = num || 0;
  }
};
export default mutations;
